/* IHSAN SUPPLY CO. — interactions. Purposeful motion only. */
(function(){
  "use strict";
  var $ = function(s,c){ return (c||document).querySelector(s); };
  var $$ = function(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  },{threshold:.12,rootMargin:'0px 0px -40px 0px'});
  $$('.reveal').forEach(function(el){ io.observe(el); });

  /* ---------- header scroll state ---------- */
  var header = $('.site-header');
  var onScroll = function(){ if(header) header.classList.toggle('scrolled', window.scrollY > 24); };
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

  /* ---------- mobile menu ---------- */
  var burger = $('.burger'), mMenu = $('.mobile-menu'), mClose = $('.mobile-close');
  if(burger && mMenu){
    burger.addEventListener('click', function(){ mMenu.classList.add('open'); document.body.style.overflow='hidden'; });
    var closeM = function(){ mMenu.classList.remove('open'); document.body.style.overflow=''; };
    if(mClose) mClose.addEventListener('click', closeM);
    $$('a', mMenu).forEach(function(a){ a.addEventListener('click', closeM); });
  }

  /* ---------- announcement rotator ---------- */
  var msgs = $$('.announce .msg');
  if(msgs.length > 1){
    var i = 0;
    setInterval(function(){
      msgs[i].classList.add('fade');
      setTimeout(function(){
        msgs[i].style.display='none';
        i = (i+1) % msgs.length;
        msgs[i].style.display='inline';
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ msgs[i].classList.remove('fade'); }); });
      }, 400);
    }, 5000);
    msgs.forEach(function(m,idx){ if(idx!==0) m.style.display='none'; });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('#cart-drawer'), overlay = $('#cart-overlay');
  var money = function(cents){
    try { return (cents/100).toLocaleString('en-US',{style:'currency',currency: (window.IHSAN && window.IHSAN.currency) || 'USD'}); }
    catch(e){ return '$'+(cents/100).toFixed(2); }
  };
  var openCart = function(){ if(drawer) drawer.classList.add('open'); if(overlay) overlay.classList.add('show'); document.body.style.overflow='hidden'; };
  var closeCart = function(){ if(drawer) drawer.classList.remove('open'); if(overlay) overlay.classList.remove('show'); document.body.style.overflow=''; };
  $$('[data-open-cart]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openCart(); }); });
  var cdClose = $('.cd-close'); if(cdClose) cdClose.addEventListener('click', closeCart);
  if(overlay) overlay.addEventListener('click', closeCart);

  var renderCart = function(cart){
    var itemsEl = $('#cd-items'), footEl = $('#cd-foot'), countEls = $$('.cart-count');
    var count = cart.item_count || 0;
    var prev = parseInt(countEls[0] ? countEls[0].textContent : '0', 10) || 0;
    countEls.forEach(function(el){ el.textContent = count; el.style.display = count ? 'grid' : 'none'; });
    if(count > prev){ countEls.forEach(function(el){ el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }); }
    if(!count){
      itemsEl.innerHTML = '<div class="cd-empty"><span class="big">✦</span><p>Your cart is empty.<br>The ritual begins with a single step.</p><a href="/collections/all" class="btn btn-primary cd-empty-cta">Shop bestsellers</a></div>';
      if(footEl) footEl.style.display = 'none';
      return;
    }
    if(footEl) footEl.style.display = '';
    itemsEl.innerHTML = cart.items.map(function(it){
      var opts = it.options_with_values ? it.options_with_values.map(function(o){return o.value;}).filter(function(v){return v!=='Default Title';}).join(' / ') : '';
      return '<div class="cd-item" data-key="'+it.key+'">'+
        '<img src="'+it.image+'" alt="">'+
        '<div class="cd-item-info"><b>'+it.product_title+'</b>'+
        (opts ? '<small>'+opts+'</small>' : '')+
        '<div class="row"><div class="cd-qty">'+
          '<button data-dec aria-label="Decrease">−</button><span>'+it.quantity+'</span><button data-inc aria-label="Increase">+</button>'+
        '</div><b>'+money(it.final_line_price)+'</b></div>'+
        '<button class="cd-remove" data-remove>Remove</button></div></div>';
    }).join('');
    var totalEl = $('#cd-total'); if(totalEl) totalEl.textContent = money(cart.total_price);
    $$('#cd-items .cd-item').forEach(function(row){
      var key = row.getAttribute('data-key');
      var dec = $('[data-dec]', row), inc = $('[data-inc]', row), rem = $('[data-remove]', row);
      var cur = parseInt($('.cd-qty span', row).textContent, 10);
      if(dec) dec.addEventListener('click', function(){ changeQty(key, cur-1); });
      if(inc) inc.addEventListener('click', function(){ changeQty(key, cur+1); });
      if(rem) rem.addEventListener('click', function(){ changeQty(key, 0); });
    });
  };
  var refreshCart = function(){
    fetch('/cart.js').then(function(r){return r.json();}).then(renderCart).catch(function(){});
  };
  var changeQty = function(key, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(renderCart).catch(function(){});
  };
  window.IHSAN_addToCart = function(id, qty, openAfter){
    var btn = document.activeElement;
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:id,quantity:qty||1})})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){ return fetch('/cart.js').then(function(r){return r.json();}); })
      .then(function(cart){ renderCart(cart); if(openAfter !== false) openCart(); });
  };
  refreshCart();

  /* quick add buttons (with success feedback) */
  document.addEventListener('click', function(e){
    var q = e.target.closest('[data-quick-add]');
    if(q){
      e.preventDefault(); q.disabled = true;
      var qLabel = q.innerHTML, isBtn = q.classList.contains('btn');
      window.IHSAN_addToCart(q.getAttribute('data-quick-add'), 1).then(function(){
        q.classList.add('is-added');
        q.innerHTML = isBtn ? '✓ Added' : '✓';
        setTimeout(function(){ q.classList.remove('is-added'); q.innerHTML = qLabel; q.disabled = false; }, 1400);
      }).catch(function(){ q.disabled = false; });
    }
  });

  /* ---------- product form ---------- */
  var form = $('#product-form');
  if(form){
    /* variant pills -> hidden select */
    var select = $('#variant-select', form);
    $$('.pill input', form).forEach(function(radio){
      radio.addEventListener('change', function(){
        if(select) select.value = radio.value;
        var priceEl = $('#p-price-now'), wasEl = $('#p-price-was'), saveEl = $('#p-price-save');
        var p = parseInt(radio.getAttribute('data-price'),10), c = parseInt(radio.getAttribute('data-compare'),10);
        if(priceEl) priceEl.textContent = money(p);
        if(wasEl){ if(c > p){ wasEl.textContent = money(c); wasEl.style.display=''; } else wasEl.style.display='none'; }
        if(saveEl){ if(c > p){ saveEl.textContent = 'SAVE '+money(c-p); saveEl.style.display=''; } else saveEl.style.display='none'; }
        var stickyP = $('#sticky-price'); if(stickyP) stickyP.textContent = money(p);
      });
    });
    /* gallery thumbs */
    var mainImg = $('#g-main-img');
    var gMain = $('.g-main');
    var showThumb = function(t){
      $$('.g-thumb').forEach(function(x){x.classList.remove('active');});
      t.classList.add('active');
      if(mainImg){ mainImg.src = t.getAttribute('data-full'); }
    };
    $$('.g-thumb').forEach(function(t){
      t.addEventListener('click', function(){ showThumb(t); });
    });
    /* swipe on main image (mobile) */
    if(gMain){
      var touchX = null;
      gMain.addEventListener('touchstart', function(e){
        touchX = e.changedTouches[0].clientX;
      }, {passive:true});
      gMain.addEventListener('touchend', function(e){
        if(touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if(Math.abs(dx) < 40) return;
        var thumbs = $$('.g-thumb');
        if(thumbs.length < 2) return;
        var cur = 0;
        thumbs.forEach(function(t,i){ if(t.classList.contains('active')) cur = i; });
        var next = dx < 0 ? (cur + 1) % thumbs.length : (cur - 1 + thumbs.length) % thumbs.length;
        showThumb(thumbs[next]);
        thumbs[next].scrollIntoView({block:'nearest', inline:'center'});
      }, {passive:true});
    }
    /* qty stepper */
    var qInput = $('#qty-input');
    $$('[data-qty]').forEach(function(b){
      b.addEventListener('click', function(){
        var v = parseInt(qInput.value,10) || 1;
        v += parseInt(b.getAttribute('data-qty'),10);
        if(v < 1) v = 1;
        qInput.value = v;
      });
    });
    /* ATC (with success morph) */
    var atc = $('#atc-btn');
    var doAdd = function(){
      var id = select ? select.value : null;
      // Fallback: if select has no value, try the checked pill radio or variant-data JSON
      if(!id){
        var checked = form.querySelector('.pill input:checked');
        if(checked) id = checked.value;
      }
      if(!id){
        var dataEl = document.getElementById('variant-data');
        if(dataEl){
          try{
            var variants = JSON.parse(dataEl.textContent);
            if(variants && variants.length) id = variants[0].id;
          }catch(e){}
        }
      }
      var qty = parseInt(qInput.value,10) || 1;
      if(!id || !atc) return;
      var label = atc.innerHTML;
      atc.disabled = true; atc.innerHTML = 'Adding…';
      window.IHSAN_addToCart(id, qty)
        .then(function(){
          atc.classList.add('is-added');
          atc.innerHTML = '✓ Added to Cart';
          setTimeout(function(){
            atc.classList.remove('is-added');
            atc.innerHTML = label;
            atc.disabled = false;
          }, 1500);
        })
        .catch(function(){ atc.innerHTML = label; atc.disabled = false; form.submit(); });
    };
    if(atc) atc.addEventListener('click', doAdd);
    var stickyBtn = $('#sticky-atc-btn');
    if(stickyBtn) stickyBtn.addEventListener('click', doAdd);
    /* sticky bar visibility */
    var stickyBar = $('#sticky-atc'), sentinel = $('#atc-btn');
    if(stickyBar && sentinel && 'IntersectionObserver' in window){
      var stickyIO = new IntersectionObserver(function(entries){
        stickyBar.classList.toggle('show', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      });
      stickyIO.observe(sentinel);
    }
  }

  /* ---------- accordions ---------- */
  $$('.acc-item').forEach(function(item){
    var head = $('.acc-head', item), body = $('.acc-body', item);
    if(!head || !body) return;
    head.addEventListener('click', function(){
      var open = item.classList.contains('open');
      $$('.acc-item.open').forEach(function(o){ o.classList.remove('open'); $('.acc-body',o).style.maxHeight = null; });
      if(!open){ item.classList.add('open'); body.style.maxHeight = body.scrollHeight + 'px'; }
    });
  });

  /* ---------- newsletter (fake submit -> thanks) ---------- */
  $$('.news-form').forEach(function(f){
    f.addEventListener('submit', function(e){
      e.preventDefault();
      var input = $('input[type="email"]', f);
      if(input && input.value.indexOf('@') > -1){
        f.innerHTML = '<p style="padding:.6rem;color:var(--gold)">✦ Welcome to the circle. Watch your inbox.</p>';
      }
    });
  });
})();

/* ============================================================
   POLISH PASS — additive behaviors (no existing logic touched)
   ============================================================ */

/* ---------- header: glide away on scroll down, back on scroll up ---------- */
(function(){
  var header = document.querySelector('.site-header');
  var drawer = document.getElementById('cart-drawer');
  if(!header) return;
  var lastY = window.scrollY;
  var update = function(){
    var y = window.scrollY;
    var blocked = document.querySelector('.mobile-menu.open') ||
                  (drawer && drawer.classList.contains('open'));
    if(!blocked && y > 320 && y > lastY){ header.classList.add('hide'); }
    else if(y < lastY || y <= 120){ header.classList.remove('hide'); }
    lastY = y;
  };
  window.addEventListener('scroll', update, {passive:true});
  var burger = document.querySelector('.burger');
  if(burger) burger.addEventListener('click', function(){ header.classList.remove('hide'); });
})();

/* ---------- hero: gentle parallax on the background ---------- */
(function(){
  var bg = document.querySelector('.hero-bg');
  if(!bg) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  window.addEventListener('scroll', function(){
    if(ticking) return; ticking = true;
    requestAnimationFrame(function(){
      var y = window.scrollY;
      if(y < window.innerHeight * 1.2) bg.style.transform = 'translateY(' + (y * 0.12) + 'px)';
      ticking = false;
    });
  }, {passive:true});
})();

/* ---------- escape closes cart drawer & mobile menu ---------- */
document.addEventListener('keydown', function(e){
  if(e.key !== 'Escape') return;
  var drawer = document.getElementById('cart-drawer'),
      overlay = document.getElementById('cart-overlay'),
      mMenu = document.querySelector('.mobile-menu.open');
  if(drawer && drawer.classList.contains('open')){
    drawer.classList.remove('open');
    if(overlay) overlay.classList.remove('show');
    document.body.style.overflow = '';
  }
  if(mMenu){ mMenu.classList.remove('open'); document.body.style.overflow = ''; }
});

/* ============================================================
   REFINEMENT PASS — B: interactions + mobile + UX (additive only)
   ============================================================ */
(function(){
  "use strict";
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- mobile menu: burger morph + aria sync ---------- */
  (function(){
    var menu = document.querySelector('.mobile-menu');
    var burger = document.querySelector('.burger');
    if(!menu || !burger) return;
    var sync = function(){
      var open = menu.classList.contains('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    };
    sync();
    if('MutationObserver' in window){
      new MutationObserver(function(muts){
        muts.forEach(function(m){ if(m.attributeName === 'class') sync(); });
      }).observe(menu, {attributes:true});
    }
  })();

  /* ---------- marquee: pause on touch ---------- */
  (function(){
    var mq = document.querySelector('.marquee');
    if(!mq) return;
    mq.addEventListener('touchstart', function(){ mq.classList.add('paused'); }, {passive:true});
    mq.addEventListener('touchend', function(){ mq.classList.remove('paused'); }, {passive:true});
    mq.addEventListener('touchcancel', function(){ mq.classList.remove('paused'); }, {passive:true});
  })();

  /* ---------- gallery: keep active thumb centered + swipe on main image ---------- */
  (function(){
    var thumbs = document.querySelector('.g-thumbs');
    var main = document.querySelector('.g-main');
    if(!thumbs) return;
    var behavior = reduceMotion ? 'auto' : 'smooth';
    thumbs.addEventListener('click', function(e){
      var t = e.target.closest('.g-thumb');
      if(!t) return;
      /* existing handler runs first (attached earlier); recenter after it */
      setTimeout(function(){
        try { t.scrollIntoView({behavior:behavior, inline:'center', block:'nearest'}); } catch(err){}
      }, 0);
    });
    if(main && !reduceMotion){
      var startX = null;
      main.addEventListener('touchstart', function(e){
        if(e.touches.length === 1) startX = e.touches[0].clientX;
      }, {passive:true});
      main.addEventListener('touchend', function(e){
        if(startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if(Math.abs(dx) < 48) return;
        var list = Array.prototype.slice.call(thumbs.querySelectorAll('.g-thumb'));
        var cur = list.findIndex(function(x){ return x.classList.contains('active'); });
        if(cur < 0) return;
        var next = dx < 0 ? list[cur + 1] : list[cur - 1];
        if(next) next.click();
      }, {passive:true});
    }
  })();

  /* ---------- sticky ATC: hide when the footer is in view ---------- */
  (function(){
    var bar = document.getElementById('sticky-atc');
    var foot = document.querySelector('.site-footer');
    if(!bar || !foot || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function(entries){
      bar.classList.toggle('hide-foot', entries[0].isIntersecting);
    }, {threshold: 0.05}).observe(foot);
  })();
})();

/* ============================================================
   REFINEMENT PASS — A: product page + cart drawer (additive only)
   No existing logic touched.
   ============================================================ */

/* ---------- A1: robust variant resolution (position-based, multi-option safe) ----------
   Liquid now emits #variant-data JSON + per-pill data-optpos/data-optval.
   Single-option products keep the existing handler; this block only takes over
   when a product has 2+ option groups, resolving the combined variant by
   option positions, and keeps the option labels ("Color: X") in sync. */
(function(){
  var form = document.getElementById('product-form');
  var dataEl = document.getElementById('variant-data');
  if(!form || !dataEl) return;
  var variants;
  try{ variants = JSON.parse(dataEl.textContent); }catch(e){ return; }
  if(!variants || !variants.length) return;
  var groups = Array.prototype.slice.call(form.querySelectorAll('.pills[data-option]'));
  if(!groups.length) return;
  var select = document.getElementById('variant-select');
  var labels = {};
  Array.prototype.forEach.call(form.querySelectorAll('[data-option-label]'), function(el){
    labels[el.getAttribute('data-option-label')] = el.querySelector('b');
  });
  var money = function(c){
    try{ return (c/100).toLocaleString('en-US',{style:'currency',currency:(window.IHSAN&&window.IHSAN.currency)||'USD'}); }
    catch(e){ return '$'+(c/100).toFixed(2); }
  };
  var syncLabels = function(){
    groups.forEach(function(g){
      var c = g.querySelector('input:checked');
      var lab = labels[g.getAttribute('data-option')];
      if(lab && c) lab.textContent = c.getAttribute('data-optval');
    });
  };
  if(groups.length < 2){
    /* single-option: existing handler covers price/select; just keep labels in sync */
    groups[0].addEventListener('change', syncLabels);
    return;
  }
  var findVariant = function(){
    var sel = groups.map(function(g){
      var c = g.querySelector('input:checked');
      return c ? c.getAttribute('data-optval') : null;
    });
    for(var i=0;i<variants.length;i++){
      var v = variants[i], ok = true;
      for(var j=0;j<sel.length;j++){
        if(sel[j] !== null && v['option'+(j+1)] !== sel[j]){ ok = false; break; }
      }
      if(ok) return v;
    }
    return null;
  };
  var atc = document.getElementById('atc-btn'), stickyBtn = document.getElementById('sticky-atc-btn');
  var atcLabel = atc ? atc.innerHTML : '', stickyLabel = stickyBtn ? stickyBtn.innerHTML : '';
  var setPrice = function(v){
    var priceEl = document.getElementById('p-price-now'),
        wasEl = document.getElementById('p-price-was'),
        saveEl = document.getElementById('p-price-save'),
        stickyP = document.getElementById('sticky-price');
    var p = v.price, c = v.compare_at_price || 0;
    if(priceEl) priceEl.textContent = money(p);
    if(wasEl){ if(c > p){ wasEl.textContent = money(c); wasEl.style.display=''; } else wasEl.style.display='none'; }
    if(saveEl){ if(c > p){ saveEl.textContent = 'SAVE '+money(c-p); saveEl.style.display=''; } else saveEl.style.display='none'; }
    if(stickyP) stickyP.textContent = money(p);
  };
  groups.forEach(function(g){
    g.addEventListener('change', function(){
      syncLabels();
      var v = findVariant();
      if(!v) return;
      if(select) select.value = v.id;
      setPrice(v);
      var avail = !!v.available;
      [[atc, atcLabel, 'Add to Cart'], [stickyBtn, stickyLabel, 'Add to Cart']].forEach(function(pair){
        var b = pair[0]; if(!b) return;
        b.disabled = !avail;
        b.innerHTML = avail ? pair[1] : 'Sold out';
      });
    });
  });
})();

/* ---------- A2: cart drawer "Pairs well with" upsell ----------
   Reads the #shop-catalog JSON blob from theme.liquid, prefers pairings
   relevant to what's in the cart, excludes items already in cart, max 3.
   Re-renders whenever the drawer items change (renderCart rewrites #cd-items). */
(function(){
  var keyOf = function(title){
    var t = String(title || '').toLowerCase();
    if(t.indexOf('smart') > -1) return 'smart';
    if(t.indexOf('travel') > -1) return 'travel';
    if(t.indexOf('gift set') > -1) return 'giftset';
    if(t.indexOf('attar') > -1) return 'attar';
    if(t.indexOf('premium tasbih') > -1) return 'premium';
    if(t.indexOf('bracelet') > -1) return 'bracelet';
    if(t.indexOf('essential') > -1) return 'essential';
    if(t.indexOf('miswak') > -1) return 'miswak';
    return '';
  };
  var PAIRS = {
    'smart':['essential','bracelet','attar'],
    'travel':['miswak','attar','bracelet'],
    'giftset':['attar','miswak','premium'],
    'attar':['miswak','bracelet','premium'],
    'premium':['attar','bracelet','essential'],
    'bracelet':['attar','essential','miswak'],
    'essential':['smart','miswak','attar'],
    'miswak':['attar','travel','bracelet']
  };
  var findByKey = function(k){
    for(var i=0;i<catalog.length;i++){ if(keyOf(catalog[i].title) === k) return catalog[i]; }
    return null;
  };
  var box = document.getElementById('cd-upsell'),
      row = document.getElementById('cd-upsell-row'),
      catEl = document.getElementById('shop-catalog'),
      itemsEl = document.getElementById('cd-items');
  if(!box || !row || !catEl || !itemsEl) return;
  var catalog;
  try{ catalog = JSON.parse(catEl.textContent); }catch(e){ return; }
  if(!catalog || !catalog.length) return;
  var money = function(c){
    try{ return (c/100).toLocaleString('en-US',{style:'currency',currency:(window.IHSAN&&window.IHSAN.currency)||'USD'}); }
    catch(e){ return '$'+(c/100).toFixed(2); }
  };
  var esc = function(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); };
  var render = function(cart){
    var inCart = {}, order = [];
    (cart.items || []).forEach(function(it){
      if(it.product_id){ inCart[it.product_id] = true; order.push(it.product_id); }
    });
    if(!order.length){ box.hidden = true; return; }
    var picked = [], seen = {};
    order.forEach(function(pid){
      var prod = null;
      for(var i=0;i<catalog.length;i++){ if(catalog[i].id === pid){ prod = catalog[i]; break; } }
      var keys = (prod && PAIRS[keyOf(prod.title)]) || [];
      keys.forEach(function(k){
        var cand = findByKey(k);
        if(cand && !inCart[cand.id] && !seen[cand.id]){ seen[cand.id] = true; picked.push(cand); }
      });
    });
    catalog.forEach(function(p){
      if(picked.length < 3 && !inCart[p.id] && !seen[p.id]){ seen[p.id] = true; picked.push(p); }
    });
    picked = picked.slice(0, 3);
    if(!picked.length){ box.hidden = true; return; }
    box.hidden = false;
    row.innerHTML = picked.map(function(p){
      return '<div class="cd-up">'+
        (p.image ? '<img src="'+esc(p.image)+'" alt="" loading="lazy">' : '')+
        '<div class="cd-up-info"><b>'+esc(p.title)+'</b><span>'+money(p.price)+'</span></div>'+
        '<button class="mini-add cd-up-add" data-quick-add="'+p.variant+'" aria-label="Add '+esc(p.title)+' to cart"><span aria-hidden="true">+</span><span class="ma-label">Add</span></button>'+
      '</div>';
    }).join('');
  };
  var t = null;
  var schedule = function(){
    clearTimeout(t);
    t = setTimeout(function(){
      fetch('/cart.js').then(function(r){ return r.json(); }).then(render).catch(function(){});
    }, 120);
  };
  if('MutationObserver' in window){
    new MutationObserver(schedule).observe(itemsEl, {childList:true});
  }
  schedule();
})();

/* ---------- A3: highlight the newly added cart row ----------
   Wraps (not replaces) window.IHSAN_addToCart: diffs the cart before/after
   the add, then pulses the new or quantity-bumped row. */
(function(){
  var orig = window.IHSAN_addToCart;
  if(!orig || orig._a3wrapped) return;
  var getCart = function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); };
  var wrapped = function(id, qty, openAfter){
    var before = null;
    return getCart().catch(function(){ return null; }).then(function(c){
      before = c;
      return orig(id, qty, openAfter);
    }).then(function(){
      return getCart().catch(function(){ return null; });
    }).then(function(after){
      if(!after || !after.items) return;
      var keys = {}, qtys = {};
      (before && before.items || []).forEach(function(it){ keys[it.key] = true; qtys[it.key] = it.quantity; });
      var target = null;
      after.items.forEach(function(it){
        if(!keys[it.key]) target = it.key;
        else if(it.quantity > (qtys[it.key] || 0) && !target) target = it.key;
      });
      if(target){
        var sel = '#cd-items .cd-item[data-key="' + target + '"]';
        var row = document.querySelector(sel);
        if(row){
          row.classList.remove('flash');
          void row.offsetWidth;
          row.classList.add('flash');
          setTimeout(function(){ row.classList.remove('flash'); }, 1700);
        }
      }
    });
  };
  wrapped._a3wrapped = true;
  window.IHSAN_addToCart = wrapped;
})();
